import moment from "moment";
import { checkValidMoment } from "../../common/common";

const userTransactionTableHeading = [
  {
    key: "transactionid",
    label: "Transaction Id",
  },
  {
    key: "transactionTime",
    label: "Transaction Time",
    format: (value) =>
      value ? checkValidMoment(value?.toDate(), "YYYY-MM-DD hh:mm A") : "N/A",
  },
  {
    key: "Itemspicked",
    label: "Items Picked",
    format: (items) =>
      Array.isArray(items) && items.length > 0
        ? items
            .map(
              ({ name, quantity, price }) =>
                `${name || "Item"}-${quantity || 0} pcs @ ₹${price || 0}/unit,`
            )
            .join("\n")
        : "No items recorded",
  },
  {
    key: "amountDeducted",
    label: "Transaction Amount",
  },
  {
    key: "Afteramount",
    label: "Wallet Balance",
  },

];

const campususerTransactionTableHeading = [
  {
    key: "phoneNumber",
    label: "Phone Number",
  },
  {
    key: "transactionid",
    label: "Transaction Id",
  },
  {
    key: "transactionTime",
    label: "Transaction Time",
    format: (value) =>
      value ? checkValidMoment(value?.toDate(), "YYYY-MM-DD hh:mm A") : "N/A",
  },
  {
    key: "Itemspicked",
    label: "Items Picked",
  },
  {
    key: "amountDeducted",
    label: "Transaction Amount",
  },
  {
    key: "Afteramount",
    label: "Wallet Balance",
  },
];

export { userTransactionTableHeading, campususerTransactionTableHeading };
